import { useQuery } from "@tanstack/react-query";
import { fetchVideoUploads, type VideoUploadsQueryParams } from "./fetchVideoUploads";

export function useVideoUploadsQuery(params: VideoUploadsQueryParams) {
	return useQuery({
		queryKey: ["getVideoUploads", params, "metadataVideos"],
		queryFn: ({ signal }) => fetchVideoUploads(params, signal),
	});
}
